import { Link } from "@tanstack/react-router";
import logo from "@/assets/nook-logo-outline.png.asset.json";
import { BRAND, UNITS } from "@/data/units";
import { openTrialDialog } from "@/components/TrialDialog";
import { track } from "@/lib/tracking";
import { openCookiePreferences } from "@/lib/consent";

export function Footer() {
  return (
    <footer className="border-t border-border bg-background pb-24 pt-16 md:pb-16">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <img src={logo.url} alt="Nook Gym" className="h-7 w-auto" width={112} height={28} loading="lazy" />
            <p className="mt-5 max-w-xs text-sm text-muted-foreground">
              {BRAND.tagline}. Até três alunos por instrutor, presença e correção durante toda a sessão.
            </p>
            <button
              type="button"
              onClick={() => {
                track("click_experimental", { where: "footer" });
                openTrialDialog("footer");
              }}
              className="mt-6 inline-flex h-11 items-center rounded-sm bg-nook-green px-5 text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-nook-green-foreground"
            >
              Garanta seu Day Use →
            </button>
          </div>

          <div className="md:col-span-3">
            <h2 className="eyebrow">Navegar</h2>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-nook-green">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/metodo-nook" className="text-muted-foreground hover:text-nook-green">
                  Método Nook
                </Link>
              </li>
              <li>
                <Link to="/unidades" className="text-muted-foreground hover:text-nook-green">
                  Unidades
                </Link>
              </li>
              <li>
                <a href="/#comunidade" className="text-muted-foreground hover:text-nook-green">
                  Comunidade
                </a>
              </li>
              <li>
                <Link to="/trabalhe-conosco" className="text-muted-foreground hover:text-nook-green">
                  Trabalhe conosco
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-5">
            <h2 className="eyebrow">Unidades</h2>
            <ul className="mt-5 space-y-5 text-sm">
              {UNITS.map((u) => (
                <li key={u.slug}>
                  <Link
                    to="/unidades/$slug"
                    params={{ slug: u.slug }}
                    className="font-medium text-foreground hover:text-nook-green"
                  >
                    {u.shortName}
                  </Link>
                  <p className="mt-1 text-muted-foreground">{u.addressLine}</p>
                  <a
                    href={u.instagram}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-1 inline-block text-xs uppercase tracking-[0.16em] text-nook-green"
                  >
                    Instagram
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Nook Gym. Todos os direitos reservados.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/politica-de-privacidade" className="hover:text-foreground">
              Privacidade
            </Link>
            <Link to="/termos-de-uso" className="hover:text-foreground">
              Termos
            </Link>
            <Link to="/excluir-conta" className="hover:text-foreground">
              Exclusão de conta
            </Link>
            <Link to="/suporte" className="hover:text-foreground">
              Suporte
            </Link>
            <button type="button" onClick={openCookiePreferences} className="hover:text-foreground">
              Preferências de cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
